import './css/App.css';
import Portfolio from './Components/Portfolio';
import ProjectPage from './Components/ProjectPage';
import CourseworkPage from './Components/CourseworkPage';
import ForagePage from './experiments/forage/ForagePage';
import PaxosPage from './experiments/paxos/PaxosPage';
import XinuPage from './experiments/xinu/XinuPage';
import archivedProjects from './data/archivedProjects';
import courseworkProjects from './data/courseworkProjects';

const projectPages = { ...archivedProjects, ...courseworkProjects };

function App() {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';

    if (path === '/experiments/forage') {
        return <ForagePage />;
    }

    if (path === '/coursework/distributed-systems' || path === '/experiments/paxos') {
        return <PaxosPage />;
    }

    if (path === '/coursework/operating-systems') {
        return <XinuPage />;
    }

    const projectPage = projectPages[path];
    if (!projectPage) {
        return <Portfolio />;
    }
    if (path.startsWith('/coursework/') && path !== '/coursework/distributed-systems') {
        return <CourseworkPage path={path} {...projectPage} />;
    }
    return <ProjectPage {...projectPage} />;
}

export default App;
